/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Start_AfterInputs */

const en_gc_guides_start_after = /** @type {(inputs: Gc_Guides_Start_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the example below to build a tiny expense table of your own. The formula in B4 should return 165. Change the groceries amount and check that the total follows. When saving, choose File > Save As, confirm the XLSX format and use the download control. Reopen the downloaded file before closing the original session. If you later exchange it with Excel users, inspect the reopened copy in Excel too, especially its formulas and formatting.`)
};

const zh_gc_guides_start_after = /** @type {(inputs: Gc_Guides_Start_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按照下面的示例创建一个小型支出表，B4 应返回 165。修改食品金额，检查合计是否同步更新。保存时选择“文件 > 另存为”，确认 XLSX 格式并点击下载。关闭会话前重新打开下载文件。如果需要与 Excel 用户交换，也请在 Excel 中复查公式和格式。`)
};

/**
* | output |
* | --- |
* | "Use the example below to build a tiny expense table of your own. The formula in B4 should return 165. Change the groceries amount and check that the total fo..." |
*
* @param {Gc_Guides_Start_AfterInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_start_after = /** @type {((inputs?: Gc_Guides_Start_AfterInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Start_AfterInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_start_after(inputs)
	return zh_gc_guides_start_after(inputs)
});
export { gc_guides_start_after as "gc.guides.start.after" }